import { CheckBoxSwitcher } from '@systemeio/ui'
import { BillingPeriodEnum } from 'modules/profile/user-plan/enums/billing-period-enum'
import {
  UseUserPlanInterface,
  tableFeatures,
} from 'modules/profile/user-plan/types/user-plan-interface'
import { isFeatureExceeded } from 'modules/profile/user-plan/utils/price-plan-utils'
import React from 'react'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { twMerge } from 'tailwind-merge'

export interface PricePlanFeaturesColumnProps {
  billingPeriod: BillingPeriodEnum
  setBillingPeriod: React.Dispatch<React.SetStateAction<BillingPeriodEnum>>
  data: UseUserPlanInterface
}

const PricePlanFeaturesColumn = ({
  billingPeriod,
  setBillingPeriod,
  data,
}: PricePlanFeaturesColumnProps) => {
  const { t } = useLocoTranslation()

  return (
    <div className="bg-brand-primary/5 my-[0.5px] flex w-1/2 flex-col gap-2 pt-10 lg:my-[1px] lg:grid lg:w-full">
      <div className="mb-6 h-[150px]">
        <div className="flex h-[150px] flex-col gap-[23px] pl-4 pr-1 pt-2">
          <b className="text-text-primary font-inter text-start text-lg">
            {t('dashboard.settings.user_plan.billing_period_title')}
          </b>
          <CheckBoxSwitcher
            selected={billingPeriod === BillingPeriodEnum.annual}
            onChange={() =>
              setBillingPeriod(prev => {
                if (prev === BillingPeriodEnum.monthly) return BillingPeriodEnum.annual
                return BillingPeriodEnum.monthly
              })
            }
            label={t('dashboard.settings.user_plan.billing_period_label')}
            labelClassName="text-text-primary min-w-[90px] text-base leading-5"
          />
        </div>
      </div>
      {tableFeatures.map((column, index) => {
        const isExceeded = isFeatureExceeded(data, billingPeriod, column)
        return (
          <React.Fragment key={`features-column-${column.key}`}>
            <div
              className={twMerge(
                'text-text-primary font-inter truncate px-4 text-left text-base font-medium',
                isExceeded && 'text-danger',
              )}
            >
              {t(column.title)}
            </div>
            {tableFeatures[index + 1] ? (
              <hr className="border-fill-primary mr-0 border-solid lg:-mr-6" />
            ) : (
              <div />
            )}
          </React.Fragment>
        )
      })}
    </div>
  )
}

export default PricePlanFeaturesColumn
